import React, { useEffect } from "react";
import {
  Container,
  SwooshSVG,
  ButtonCard,
  ContainerColor,
  ContainerInner,
  Title,
  LocationWrapper,
  LocationNameWrapper,
  ContainerText,
} from "./CardRegister.styled";
import { func } from "../../../utils";
import Chip from "../Chip";
import { useCountdown } from "../../../hooks/useCountdown";
import useWindowSize from "../../../hooks/useWindowSize";
import moment from "moment";
import { useCitySchool, useUserData } from "../../../store/user";
import { useNavigate } from "react-router-dom";
import { capitalizeFLetter } from "../../../utils/function";

const CardRegister = ({ data }) => {
  const { size } = useWindowSize();
  const isMobileView = (size?.width || 0) <= 830;
  const { accessToken } = useUserData();
  const navigate = useNavigate();
  const { citySchool, setCitySchool } = useCitySchool();
  const currentDate = moment();
  const startDate = moment(data?.event_start_date);
  const endDate = moment(data?.event_end_date);
  const diffDays = startDate?.diff(currentDate, "days") + 1;
  const isSameMonthEvent = startDate.format("MMMM") === endDate.format("MMMM");

  const isSmallScreen = (size?.height || 0) <= 667;

  const isExtraSmallScreen =
    (size?.width || 0) <= 375 && (size?.height || 0) <= 600;
  const isLogin = !!accessToken;
  const viewData = React.useMemo(() => {
    return {
      badge: `${diffDays} HARI LAGI`,
      badgeBackgroundColor: "#0397C9",
      buttonText: "Daftarkan Tim Kamu",
      buttonDisabled: false,
      buttonBgColor: "#00BCF1",
      buttonBorderColor: "#00BCF1",
      buttonTextColor: "#fff",
      onClick: () => {
        if (isLogin) {
          return navigate("/");
        } else {
          const cardDate = isSameMonthEvent
            ? `${startDate?.format("D")} - ${endDate?.format("D MMMM")}`
            : `${startDate?.format("D MMMM")} - ${endDate?.format("D MMMM")}`;

          setCitySchool({
            ...data,
            cardDate,
            region_name: capitalizeFLetter(String(data?.city)?.toLowerCase()),
          });
          return navigate(`/${String(data?.city)?.toLowerCase()}/registrasi`);
        }
      },
    };
  });

  return (
    <>
      <Container
        scale={isExtraSmallScreen ? "0.75" : "1"}
        marginBottom={
          isExtraSmallScreen ? "-20px" : isSmallScreen ? "0px" : "20px"
        }
      >
        <ContainerColor>
          <Chip
            text={viewData.badge}
            backgroundColor={viewData.badgeBackgroundColor}
            color={"#fff"}
          />
          <SwooshSVG
            src={func.getStaticImg(
              isMobileView ? "/bg/swosh-abstrac.svg" : "/bg/swosh-abstrac_d.svg"
            )}
          />
          <ContainerInner>
            <ContainerText>
              <LocationWrapper>
                <img
                  src={func.getStaticImg(
                    isMobileView
                      ? `/illustration/pin location.svg`
                      : `/illustration/pin location-d.svg`
                  )}
                />
                <LocationNameWrapper>
                  <Title
                    color={"#1F2D3D"}
                    fontWeight={"700"}
                    fontSize={isMobileView ? "12px" : "32px"}
                    lineHeight={isMobileView ? "16px" : "40px"}
                  >
                    {data?.location}
                  </Title>
                </LocationNameWrapper>
              </LocationWrapper>
              <Title
                fontSize={isMobileView ? "12px" : "18px"}
                lineHeight={isMobileView ? "16px" : "24px"}
                color={"#6A7481"}
              >
                {`${data?.city}, ${data?.event_date}`}
              </Title>
            </ContainerText>
            <ButtonCard
              disabled={viewData.buttonDisabled}
              color={viewData.buttonTextColor}
              backgroundColor={viewData.buttonBgColor}
              borderColor={viewData.buttonBorderColor}
              onClick={viewData?.onClick}
            >
              {viewData.buttonText}
            </ButtonCard>
          </ContainerInner>
        </ContainerColor>
      </Container>
    </>
  );
};

export default CardRegister;
